import * as React from "react";
import { NotificationSubscription } from "webportalclient";
import { isModelWithError } from "../misc/api/apiTypes";
import { useWebPortalLegacyClient } from "../misc/api/WebPortalTokenClient";
import Alert, { AlertCategoryEnum } from "../misc/components/Alert";
import LoadingWithMessage from "../misc/components/LoadingWithMessage";
import Modal, { ModalSize } from "../misc/components/modal";
import { NotificationConfig } from "./ConfigureNotification";
import { NotificationPlugin } from "./NotificationTypes";

interface EditNotificationProps {
    existingSubscription: NotificationSubscription;
    onClose: () => void;
}

export const EditNotification = ({ existingSubscription, onClose }: EditNotificationProps) => {
    const legacyClient = useWebPortalLegacyClient();
    const [selectedTemplate, setSelectedTemplate] = React.useState<NotificationPlugin>();
    const [error, setError] = React.useState<undefined | string>();

    React.useEffect(() => {
        const getData = async () => {
            try {
                const notificationPluginsResult = await legacyClient.getNotificationPlugins();
                if (isModelWithError(notificationPluginsResult))
                    return setError("Failed to load the notification templates. Please contact an Administrator.");

                const notificationTemplate = notificationPluginsResult.find(x => x.Id === existingSubscription.pluginId);

                setSelectedTemplate(notificationTemplate);
            } catch (ex) {
                setError("Failed to load the notification templates. Please contact an Administrator.");
            }
        }

        getData();
    }, [existingSubscription]);

    return (
        <Modal show={true} size={ModalSize.Large} closeModalHandler={onClose}>
            <Alert show={error !== undefined} category={AlertCategoryEnum.Danger}>{error}</Alert>
            {!selectedTemplate ? <LoadingWithMessage message="Loading edit notification..." />
                : <NotificationConfig isEdit={true} existingSubscription={existingSubscription} selectedTemplate={selectedTemplate} onClose={onClose} />
            }
        </Modal>
    );
}
